<template>
<div style="height: 100%;background-color: #fbfbfb">
  <div style="height: calc(100% - 20px);margin: 0 20px;padding-top: 20px">
    <el-row style="height: 100%;">
      <el-col :span="24" style="height: 100%;">
        <div style="height: 100%;margin: 0 20px">
          <div style="height: 50px;">
            <el-button type="primary" plain icon="el-icon-plus" @click="addOpen()">新增护理记录</el-button>
            <el-select v-fixZoom v-model="filterType" placeholder="请选择" style="width: 130px">
              <el-option v-for="item in filterTypeArr" :key="item.value" :label="item.name" :value="item.id"></el-option>
            </el-select>
            <el-input v-model="filterText" prefix-icon="el-icon-search" placeholder="请输入" clearable style="width: 250px"></el-input>
            <el-date-picker v-fixZoom :clearable="false" v-model="sendDate" type="daterange" unlink-panels
                            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
                            value-format="yyyy-MM-dd" style="margin-right: 10px; width: 400px">
            </el-date-picker>
            <el-button type="success" @click="getSearchData">查询</el-button>
          </div>
          <div style="height: calc(100% - 100px)">
            <el-table :data="tableData" border highlight-current-row height="100%">
              <el-table-column
                type="index"
                label="序号"
                width="70"
                align="center">
              </el-table-column>
              <el-table-column
                prop="s_name"
                label="护理类别"
                min-width="100"
                align="center">
              </el-table-column>
              <el-table-column
                prop="Person_name"
                label="老人姓名"
                min-width="120"
                align="center">
              </el-table-column>
              <el-table-column
                prop="room_name"
                label="房间"
                min-width="80"
                align="center">
              </el-table-column>
              <el-table-column
                prop="bed_name"
                label="床位"
                min-width="100"
                align="center">
              </el-table-column>
              <el-table-column
                prop="svs_esp_name"
                label="服务人员"
                min-width="120"
                align="center">
              </el-table-column>
              <el-table-column
                prop="svs_time"
                label="服务时间"
                width="100"
                align="center">
              </el-table-column>
              <el-table-column
                prop="svs_items"
                label="本次护理项目"
                min-width="120"
                align="center">
              </el-table-column>
              <el-table-column
                prop="svs_remarks"
                label="本次服务备注"
                min-width="120"
                align="center">
              </el-table-column>
              <el-table-column align="center" label="操作" width="200">
                <template slot-scope="scope">
                  <el-button size="mini" type="primary" plain @click="editOpen(scope.row)">修改</el-button>
                  <el-button size="mini" type="danger" plain @click="delOpen(scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div style="margin-top: 10px;height: 40px;text-align: center">
            <el-pagination v-fixZoom @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                           :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalCells"
                           layout="total, sizes, prev, pager, next, jumper">
            </el-pagination>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
  <el-dialog :visible.sync="addEditShow" v-if="addEditShow" width="800px"
             :show-close="true" :close-on-click-modal="false" center class="all-open">
    <div class="title-top-alarm">
      <span>{{ addEditTitle }}</span>
      <div class="line-title"></div>
    </div>
    <add-edit-service-record :addEditObj="addEditObj" v-model="addEditShow" @updateTable="updateTable"></add-edit-service-record>
  </el-dialog>
</div>
</template>

<script>
import {
  queryeservicepersonrecordlist,
  updateeservicepersonrecord
} from '../../api/yanglaoyuan/eservice'
import addEditServiceRecord from './components/addEditServiceRecord'

export default {
  name: 'serviceRecord',
  components: {addEditServiceRecord},
  data () {
    return {
      entityId: 0,
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      filterTypeArr: [{id: 1, name: '老人姓名'}, {id: 2, name: '房间名称'}, {id: 3, name: '床位名称'}, {id: 4, name: '服务人员姓名'}],
      filterType: 1,
      filterText: '',
      sendDate: [],
      pickerOptions: {
        // disabledDate (time) {
        //   return time.getTime() > Date.now()
        // },
        shortcuts: []
      },
      tableData: [],

      addEditTitle: '',
      addEditShow: false,
      addEditObj: {
        openType: 0,
        row: ''
      }
    }
  },
  created () {
    let loginResp = this.$store.state.user.LoginResp
    this.entityId = loginResp.entity_id
    this.getTimeObj()
    // eslint-disable-next-line no-extend-native
    Date.prototype.format = this.validate.format
    let end = new Date().format('yyyy-MM-dd')
    const start = this.commonType.GetDateStr(-30)
    this.sendDate = [start.format('yyyy-MM-dd'), end]
    this.getSearchData()
  },
  methods: {
    // 时间
    mGetDate (year, month) {
      const d = new Date(year, month, 0)
      return d.getDate()
    },
    getTimeObj () {
      const dataArr = []
      const data = new Date()
      data.setMonth(data.getMonth() + 1, 1)// 获取到当前月份,设置月份
      for (let i = 0; i < 12; i++) {
        data.setMonth(data.getMonth() - 1) // 每次循环一次 月份值减1
        let m = data.getMonth() + 1
        m = m < 10 ? '0' + m : m
        dataArr.push(data.getFullYear() + '-' + (m))
      }
      const endDate = []
      for (let i = 1; i < dataArr.length; i++) {
        const arr = dataArr[i].split('-')
        const obj = {}
        let endDay = ''
        if (arr[1][0] === '0') {
          endDay = this.mGetDate(parseInt(arr[0]), parseInt(arr[1][1]))
          obj.text = arr[0] + '年' + arr[1][1] + '月'
        } else {
          endDay = this.mGetDate(parseInt(arr[0]), parseInt(arr[1]))
          obj.text = arr[0] + '年' + arr[1] + '月'
        }
        obj.start = arr[0] + '-' + arr[1] + '-' + '01'
        obj.end = arr[0] + '-' + arr[1] + '-' + endDay
        endDate.push(obj)
      }
      const arrTime = [
        {
          text: '本月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setDate(1)
            picker.$emit('pick', [start, end])
          }
        }
      ]
      for (let i = 0; i < endDate.length; i++) {
        const item = {
          text: endDate[i].text,
          onClick (picker) {
            picker.$emit('pick', [endDate[i].start, endDate[i].end])
          }
        }
        arrTime.push(item)
      }
      this.pickerOptions.shortcuts = arrTime
    },
    getSearchData () {
      this.getEservicePersonRecordData()
    },
    updateTable () {
      this.getEservicePersonRecordData()
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.getSearchData()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getSearchData()
    },

    addOpen () {
      this.addEditTitle = '新增护理记录'
      this.addEditObj.openType = 1
      this.addEditObj.row = ''
      this.addEditShow = true
    },
    editOpen (row) {
      this.addEditTitle = '修改'
      this.addEditObj.openType = 2
      this.addEditObj.row = row
      this.addEditShow = true
    },
    delOpen (row) {
      this.$confirm('此操作将删除该护理记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let data = {
          oper_type: 2,
          eid: row.eid,
          id: row.id
        }
        updateeservicepersonrecord(data).then(res => {
          this.$notify({title: '成功', message: '成功删除该护理记录', type: 'success', duration: 2000})
          this.updateTable()
        })
      })
    },

    // 访问接口
    // 获取护理记录
    getEservicePersonRecordData () {
      let params = {
        page: this.currentPage,
        size: this.pageSize
      }
      let data = {
        eid: this.entityId,
        elderly_name: this.filterType === 1 ? this.filterText : '',
        room_name: this.filterType === 2 ? this.filterText : '',
        bed_name: this.filterType === 3 ? this.filterText : '',
        svs_esp_name: this.filterType === 4 ? this.filterText : '',
        start_time: this.sendDate[0] + ' 00:00:00',
        end_time: this.sendDate[1] + ' 23:59:59'
      }
      queryeservicepersonrecordlist(params, data).then(res => {
        this.tableData = res.data.arrdata
        this.totalCells = res.data.cnt
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/serviceRecord.vue